import { useHttp } from "../http/useHttp";
import { useAxiosQuery } from "../http/useAxiosQuery";
import { useMemo } from "react";
import { IS_ENABLED_REPORTS } from "../../utils/environment";
import { useAuth } from "../auth/useAuth";

export interface INodeBalance {
  onchain_confirmed_balance?: number | null;
  onchain_unconfirmed_balance?: number | null;
  channel_reserves?: number | null;
  lightning_inbound_capacity?: number | null;
  lightning_outbound_capacity?: number | null;
  lightning_pending_local?: number | null;
  lightning_pending_remote?: number | null;
  pending_open_channel_amount?: number | null;
  pending_close_channel_amount?: number | null;
  pending_force_close_channel_amount?: number | null;
  largest_outbound_capacity_channel_amount?: number | null;
}

export const useNodeBalance = () => {
  const { client } = useHttp();
  const { isAdmin } = useAuth();

  const { status, isPending, isFetching, isLoading, data, error, refetch } =
    useAxiosQuery<INodeBalance>({
      queryKey: ["current-node-balance"],
      queryFn: ({ signal }) => client.get("/synota/current-node-balance", { signal }),
      retry: 1,
      enabled: Boolean(IS_ENABLED_REPORTS && isAdmin),
    });

  const balance = useMemo(() => {
    if (!data) {
      return {};
    }
    return data.data;
  }, [data]);

  const totalAvailable = useMemo(
    () =>
      (balance.onchain_confirmed_balance || 0) +
      (balance.onchain_unconfirmed_balance || 0) +
      (balance.channel_reserves || 0) +
      (balance.lightning_outbound_capacity || 0),
    [balance],
  );

  return {
    balance,
    totalAvailable,
    error,
    isLoading,
    isFetching,
    isPending,
    status,
    refetch,
  };
};

export type UseNodeBalanceReturn = ReturnType<typeof useNodeBalance>;
